import noop from 'lodash/noop';

import PropTypes from 'prop-types';

import { Button } from '@src/components';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from './Dialog';

const styles = {
  root: {
    '& .MuiDialog-paper': {
      width: '80%',
      borderRadius: 3,
      maxHeight: 435,
    },
  },
  title: {
    paddingTop: 2.5,
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 700,
  },
  content: {
    fontSize: 16,
    lineHeight: 1.5,
    textAlign: 'center',
  },
  actions: {
    paddingBottom: 2.5,
    justifyContent: 'center',
  },
};

function AlertDialog(props) {
  const {
    open = false,
    title = 'Alert',
    children,
    onConfirm = noop,
    onClose = noop,
    slotProps = {},
    ...restProps
  } = props;

  const { cancelButton: cancelButtonProps, confirmButton: confirmButtonProps } = slotProps || {};

  const {
    show: showCancelButton = true,
    label: cancelButtonLabel = 'No',
    ...restCancelButtonProps
  } = cancelButtonProps || {};
  const {
    show: showConfirmButton = true,
    label: confirmButtonLabel = 'Yes',
    ...restConfirmButtonProps
  } = confirmButtonProps || {};

  return (
    <Dialog maxWidth="xs" sx={styles.root} open={open} {...restProps}>
      <DialogTitle sx={styles.title}>{title}</DialogTitle>
      <DialogContent sx={styles.content}>{children}</DialogContent>

      <DialogActions sx={styles.actions}>
        {showCancelButton
          ? (
            <Button variant="outlined" {...restCancelButtonProps} onClick={onClose} >
              {cancelButtonLabel}
            </Button>
          )
          : null}

        {showConfirmButton
          ? (
            <Button variant="contained" {...restConfirmButtonProps} onClick={onConfirm} >
              {confirmButtonLabel}
            </Button>
          )
          : null}
      </DialogActions>
    </Dialog>
  );
}

AlertDialog.displayName = 'AlertDialog';
AlertDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  slotProps: PropTypes.object,
};
export default AlertDialog;
